// src/routes.tsx
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import Home from './views/Home/Home';
import Fleet from './views/Fleet/Fleet';
import Commodore from './views/Fleet/Commodore';
import Rentals from './views/Rentals/Rentals';
import About from './views/About/About';
import Contact from './views/Contact/Contact';
import Serenity from './views/Fleet/Serenity';

export const routeList = [
  { path: '/', element: <Home />, title: 'Earthbound Martian | Landships for Rent' },
  { path: '/fleet', element: <Fleet />, title: 'Fleet | Earthbound Martian' },
  { path: '/fleet/commodore', element: <Commodore />, title: 'Commodore | Earthbound Martian' },  
  { path: '/fleet/serenity', element: <Serenity />, title: 'Serenity | Earthbound Martian' },  
  { path: '/rentals', element: <Rentals />, title: 'Rentals | Earthbound Martian' },
  { path: '/about', element: <About />, title: 'About | Earthbound Martian' },
  { path: '/contact', element: <Contact />, title: 'Contact | Earthbound Martian' },
];

export const AppRoutes = () => (
  <RouterRoutes>
    {routeList.map((route) => (
      <Route key={route.path} path={route.path} element={route.element} />
    ))}
  </RouterRoutes>
);